import { t } from '@lingui/core/macro';

import { OrganizerSubscriptionSummary } from '../interfaces/organizer-list-item';

/**
 * Formats subscription expiry for display in organizer row.
 * Returns:
 * - activeTo date (YYYY-MM-DD only) when status is ACTIVE
 * - "Истекла" when status is EXPIRED
 * - "Нет" when status is NONE or subscriptionSummary is undefined/null
 *
 * Подписи переводятся внутри функции — на языке момента вызова.
 */
export function formatSubscriptionExpiry(subscriptionSummary?: OrganizerSubscriptionSummary | null): string {
  const none = t({ message: 'Нет', comment: 'Подписки нет' });

  if (!subscriptionSummary) {
    return none;
  }

  switch (subscriptionSummary.status) {
    case 'ACTIVE':
      if (!subscriptionSummary.activeTo) {
        return none;
      }
      return subscriptionSummary.activeTo.split('T')[0];
    case 'EXPIRED':
      return t({ message: 'Истекла', comment: 'Подписка истекла' });
    case 'NONE':
      return none;
    default:
      return none;
  }
}
